var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClickaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ads_click"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6133 23.9866C11.3733 23.7866 7.99996 20.2933 7.99996 16C7.99996 11.5866 11.5866 7.99996 16 7.99996C20.2933 7.99996 23.7866 11.3733 23.9866 15.6133L21.1866 14.7733C20.64 12.4133 18.52 10.6666 16 10.6666C13.0533 10.6666 10.6666 13.0533 10.6666 16C10.6666 18.52 12.4133 20.64 14.7733 21.1866L15.6133 23.9866ZM29.3333 16C29.3333 16.4 29.32 16.8 29.28 17.2L26.6533 16.4133C26.6666 16.28 26.6666 16.1333 26.6666 16C26.6666 10.1066 21.8933 5.33329 16 5.33329C10.1066 5.33329 5.33329 10.1066 5.33329 16C5.33329 21.8933 10.1066 26.6666 16 26.6666C16.1333 26.6666 16.28 26.6666 16.4133 26.6533L17.2 29.28C16.8 29.32 16.4 29.3333 16 29.3333C8.63996 29.3333 2.66663 23.36 2.66663 16C2.66663 8.63996 8.63996 2.66663 16 2.66663C23.36 2.66663 29.3333 8.63996 29.3333 16ZM24.3066 21.68L29.3333 20L16 16L20 29.3333L21.68 24.3066L27.3733 30L30.0133 27.36L24.3066 21.68Z",
    fill: "#29ABE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClickaction);
export default __webpack_public_path__ + "static/media/clickaction.2fb71e3f235096b75d97941c8355f77e.svg";
export { ForwardRef as ReactComponent };